export const JUST_UNIT_PRICE_DESCRIPTOR = "Base unit price";
export const JUST_UNIT_COST_DESCRIPTOR = "Base unit cost";
export const TOTAL_ESTIMATE_DESCRIPTOR = "Initial cost projection";
export const INSTANT_QUOTE_DESCRIPTOR = "Instant Quote";
export const READYBUILT_UPGRADE_TEXT = "Upgrade value";

export const UPGRADES_LIMITED = "Limited upgrades available";
export const UPGRADES_AVAILABLE = "Upgrades available";
